import React from "react";
import { CalculatorCore } from "./Calculator/CalculatorCore";

export const DashboardCalculator: React.FC = () => {
  return <CalculatorCore mode="compact" showFullButton={true} />;
};
